<template>
	<div class="orders-view">
		<nav-bar>我的订单</nav-bar>
		<div class="list" v-if="!loading && list.length">
			<div class="list-item" v-for="(item, index) in list" :key="index" @click="onClickOrder(item)">
				<div class="header">
					<div class="time">
						<template v-if="item.isHubBookingOrder">
							{{item.hubOrderDateTimeDesc}}(预约单)
						</template>
						<template v-else>{{item.date}} {{item.time}}(随时出发)</template>
					</div>
					<div class="status">
						<div class="status-text" :style="`color: ${item.statusColor};`">
							{{ item.isHubOrder ? HUB_ORDER_STATUS_MAP[item.status] : item.statusText }}
						</div>
						<img src="../../assets/img-v2/ic_user_arrow.png" class="arrow"/>
					</div>
				</div>
				<div class="row">
					<div class="dot on"></div>
					<div class="name">{{item.onStopName}}</div>
				</div>
				<div class="row">
					<div class="dot off"></div>
					<div class="name">{{item.offStopName}}</div>
				</div>
			</div>
		</div>
		<div class="empty" v-if="!loading && !list.length">您还没有订单哦~</div>
	</div>
</template>
<script>
import { HUB_ORDER_STATUS_MAP } from "@/const/hub-status";
import NavBar from "../../components/nav-bar/index";
import { convertHubOrder } from './convert-hub-order';

let loadingToast;
export default {
	name: 'Orders',
	components: {NavBar},
	data() {
		return {
			HUB_ORDER_STATUS_MAP,
			list: [],
			loading: false
		}
	},
	watch: {
		loading(loading) {
			if (!loadingToast) {
				loadingToast = this.$createToast({
					type: 'loading',
					text: '加载中...'
				});
			}
			if (loading) {
				loadingToast.show();
			} else {
				loadingToast.hide();
			}
		}
	},
	activated() {
		this.$nextTick(() => {
			this.getOrderList();
		});
	},
	methods: {
		getOrderList() {
			this.loading = true;
			this.$OrderService.getOrderList().then((list) => {
				this.list = [...list].map(item => {
					return {
						...item,
						...convertHubOrder(item)
					}
				});
				this.loading = false;
			}).catch((res) => {
				this.loading = false;
				this.$toast(res.msg);
			});
		},
		onClickOrder(item) {
			this.$AppService.setTicketInfoId(item.id);
			this.$OrderService.turnToOrderInfo({}, {
				ticketInfoId: item.id
			});
		}
	}
}
</script>

<style scoped lang="scss">
	.orders-view {
		background: #F3F4F5;
		min-height: 100vh;
		z-index: 100;
		.list {
			padding: 10px;
			&-item {
				background: #FFFFFF;
				border-radius: 12px;
				padding: 0 14px;
				margin-bottom: 10px;

				.header {
					display: flex;
					padding: 22px 0;
				}
				.time {
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 16px;
					color: #000000;
					line-height: 22px;
					flex: 1;
				}
				.status {
					display: flex;
					align-items: center;
					&-text {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 16px;
						color: #666666;
						line-height: 22px;
					}
					.arrow {
						width: 12px;
						height: 12px;
					}
				}
				.row {
					display: flex;
					padding-bottom: 18px;
				}

				.dot {
					width: 8px;
					height: 8px;
					border-radius: 50%;
					margin: 7px 8px 0 0;
				}
				.on {
					background: #04B47C;
				}
				.off {
					background: #006EFA;
				}

				.name {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: rgba(0,0,0,0.7);
					line-height: 22px;
					flex: 1;
				}
			}
		}
		.empty {
			width: 100%;
			text-align: center;
			position: absolute;
			top: 50%;
			left: 0;
			transform: translate3d(0, -50%, 0);
			font-size: 17px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 23px;
		}
	}
</style>
